import { render, staticRenderFns } from "./ModalGroupEdit.vue?vue&type=template&id=71961c4b&scoped=true"
import script from "./ModalGroupEdit.vue?vue&type=script&lang=js"
export * from "./ModalGroupEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalGroupEdit.vue?vue&type=style&index=0&id=71961c4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71961c4b",
  null
  
)

export default component.exports